import type { IPopup } from "@mm-frontend/mm-web-ui-kit";
import { SignInCodeStepForm } from "./SignInCodeStepForm";
import { SignInCodeStepRetryForm } from "./SignInCodeStepRetryForm";
import { ref } from "vue";

export class SignInCodeStepController {
  public popup: IPopup;
  public form: SignInCodeStepForm;
  public retryForm: SignInCodeStepRetryForm;
  public isRetryLoading = ref(false);
  public allowRetry = ref(false);

  public otpError: Ref<string> = ref('');

  constructor({ popup }: { popup: IPopup }) {
    this.popup = popup;
    this.form = new SignInCodeStepForm();
    this.retryForm = new SignInCodeStepRetryForm();
  }

  public getRetryErrorMessage(error: any) {
    const errorCode = error.response?.status;
    let errorMessage;

    switch (errorCode) {
      case 422:
        errorMessage = 'Ещё действует прошлый код. Можете запросить новый через несколько минут';
        break;
      default:
        errorMessage = 'Код не отправился. Попробуйте еще раз или запросите код позже';
    }

    return errorMessage;
  }

  public async getSubmitCodeErrorMessage(error: any) {
    const errorCode = error?.data?.code as string;
    let errorMessage;

    switch (errorCode) {
      case 'otpTooManyChecks':
        errorMessage = 'Вы ввели код слишком много раз. Попробуйте снова через 1-3 часа';
        break;
    }

    return errorMessage;
  }
}